export const LEGAL_ID_SAVE = 'LEGAL_ID_SAVE';
export const SEARCH_LEGAL_ID_SAVE = 'SEARCH_LEGAL_ID_SAVE';
export const IS_MAIN_DRIVER_SAVE = 'IS_MAIN_DRIVER_SAVE';
